import React from "react";
import { Text, View } from "@react-pdf/renderer";

export const SingleDayActivityTypeColumns = props => {
  const { categoryName, styles } = props;

  return (
    <View style={styles.borderType}>
      <View style={styles.product}>
        <Text style={styles.text}>{categoryName}</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Reste</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Btq</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Adj B</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Dlv</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Adj D</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Chr</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Adj C</Text>
      </View>
      <View style={styles.type}>
        <Text style={styles.textType}>Tot</Text>
      </View>
    </View>
  );
};
